import Image from "next/image";
import { GiftPackagingTabProps } from "../../types";
import NoImageSrc from "@/assets/images/no_image.svg";
import { getCloudinaryURL } from "@/utils/cloudinary";

const GiftPackaging = ({ data, label, id }: GiftPackagingTabProps & { id?: string }) => {
  return (
    <div id={id} className="flex h-full flex-col-reverse items-center justify-center max-md:px-5 max-md:py-5 lg:flex-row text-sm md:text-base ">
      <div className="flex flex-1 flex-col items-center gap-6 py-5">
        <div className="lg:w-[95%]">
          {data?.items?.map((item, idx) => {
            return (
              <div key={idx} className="flex items-center gap-3 py-4">
                <Image
                  src={item?.icon ?? NoImageSrc}
                  alt="icon"
                  width={20}
                  height={20}
                  className="h-8 w-6"
                />
                <span>{item.title}</span>
              </div>
            );
          })}
        </div>
      </div>
      <div className="flex flex-1 items-center justify-center">
        <Image
          src={data?.media?.desktop ? getCloudinaryURL(data?.media?.desktop) : NoImageSrc}
          alt="img"
          width={708}
          height={608}
          className="hidden w-full md:block"
        />
        <Image
          src={data?.media?.mobile ? getCloudinaryURL(data?.media?.mobile) : NoImageSrc}
          alt="img"
          width={708}
          height={608}
          className="w-full md:hidden"
        />
      </div>
    </div>
  );
};

export default GiftPackaging;
